import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Box, Paper, Typography } from "@mui/material";

const QRCodeGenerator = ({ value, size = 240, eventName = "QR Event" }) => {
  if (!value) return null;
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
      <Paper elevation={4} sx={{ p: 3, borderRadius: 3, textAlign: 'center', backgroundColor: '#f8f9fa' }}>
        <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {eventName}
        </Typography>
        <Box sx={{ 
          position: 'relative',
          display: 'inline-block',
          p: 2,
          backgroundColor: 'white',
          borderRadius: 2,
          boxShadow: 2
        }}>
          <QRCodeCanvas 
            value={value} 
            size={size} 
            includeMargin={true} 
            level="M"
            style={{ borderRadius: 8 }}
          />
          {/* Brand overlay */}
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            borderRadius: '50%',
            width: 60,
            height: 60,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 2,
            border: '3px solid #1976d2'
          }}>
            <Typography variant="h4" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
              QR
            </Typography>
          </Box>
        </Box>
        <Typography variant="body2" sx={{ mt: 2, color: '#666', fontStyle: 'italic' }}>
          Scan this QR code to join the event
        </Typography>
        <Typography variant="caption" sx={{ mt: 1, color: '#999', display: 'block' }}>
          Make sure you're at the correct location
        </Typography>
      </Paper>
    </Box>
  );
};

export default QRCodeGenerator;


